import { SECONDS_IN_HOUR, SECONDS_IN_DAY } from 'cio/utils/constants';

export const DEFAULT_MESSAGE_RETRY_WINDOW_SECS = SECONDS_IN_HOUR;

export const MAX_MESSAGE_RETRY_WINDOW_SECS = SECONDS_IN_DAY * 2;

export function isAutoRetryWindowCorrect(seconds: number | undefined | null) {
  let value = seconds ?? 0;
  return value > 0 && value <= MAX_MESSAGE_RETRY_WINDOW_SECS;
}

export function isAutoRetryWindowValueValid(seconds: number | undefined | null) {
  let value = seconds ?? 0;
  return value === 0 || isAutoRetryWindowCorrect(value);
}
